module.exports = __webpack_public_path__ + "static/media/Data_insight_en_3-4.1133a6bb.svg";